export enum ProductType {
  WhatsApp = 1,
  Voice = 2,
  Recharge = 3,
  Slot = 4,
  Summary = 5,
  Sms = 6,
  Register = 7,
  Upgrade = 8,
  Downgrade = 9,
  EditPlan = 10,
  BotAI = 11,
  WhatsAppVoice = 12,
  TextToSpeech = 13,
  ApiCalls = 14,
}

export enum BillingType {
  Prepaid = 1,
  Postpaid = 2,
}
